/// <reference path="../../../../../rcwebmodels/devicedetails.cs.d.ts" />

import * as React from 'react';
import ReactMoment from 'moment';
import DateFormat from 'dateformat';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';

import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
//import { DateTime } from 'react-datetime-bootstrap';
import * as Autosuggest from 'react-autosuggest';
import Formatters from '../../actions/Formatters';
var Config: any = require('../../Config.json');

interface EditAssetPropertiesState {
     IsChecked: boolean
    , suggestionsAssetNumber: any[]
    , targetId: string
    , isLoading: boolean
    , PreferenceDTTM: any
    , DryAssetDetails: server.DryAssetDetails
    , prevDryAssetDetails: server.DryAssetDetails
    ,IsActive: boolean
}
var fromDateOnChangeFired = false;
var toDateOnChangeFired = false;
var assetDetailsChanged = false;
var fromDate = DateFormat(new Date(Date.now()), 'mm/dd/yyyy HH:MM:ss');
var fromDTTM = new Date(Date.now());
fromDTTM.setDate(fromDTTM.getDate() + 30);
var toDate = DateFormat(new Date(fromDTTM), 'mm/dd/yyyy HH:MM:ss');

var newAssetDetails: server.DryAssetDetails = {
    AssetMasterID: 0, AssetNumber: '',DeviceNumber: '', FromDate: fromDate, ToDate: toDate,  isAssetDetailsChanged: false,RCDMasterID:0
};
class AssetNumberSearchList {
    AssetNumberList: any[] = [];
    AssetNumberDistinctList: any[] = [];
}
var Assetlst = new AssetNumberSearchList();
export class EditAsset extends React.Component<any, EditAssetPropertiesState> {
    constructor(props: any) {
        super(props);
        var currentUtcDttm = ReactMoment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var assetDetails: server.DryAssetDetails = {
            AssetNumber: this.props.refData[0].AssetNumber != null ? this.props.refData[0].AssetNumber :"", AssetMasterID: this.props.refData[0].AssetMasterID,
            DeviceNumber: this.props.refData[0].RCDID,
            RCDMasterID: this.props.refData[0].RCDMasterID,
        };
        this.state = {
            IsChecked: false, targetId: '', suggestionsAssetNumber: [],
            isLoading: true, PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            DryAssetDetails: newAssetDetails, prevDryAssetDetails: assetDetails,
            IsActive: this.props.refData[0].IsActive
        };

        Assetlst.AssetNumberList = [];
        
            var url = Config.ApiBaseUrl + '/api/RcdStatus/GetDryAssets?customerId=' + this.props.refData[0].CustomerID;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.DryAssetList[]>)
            .then(data => {
                if (data.length > 0) {
                    Assetlst.AssetNumberList = [];
                    $.each(data, function (i, n) {
                        Assetlst.AssetNumberList.push(data[i].AssetNumber);
                    });
                }
                $('#globalLoader').hide();
            });
    }
    componentDidMount() {
        //$('#globalLoader').show();

            var assetDetails: server.DryAssetDetails = {
                AssetNumber: this.props.refData[0].AssetNumber != null ? this.props.refData[0].AssetNumber : "", AssetMasterID: this.props.refData[0].AssetMasterID,
                DeviceNumber: this.props.refData[0].RCDID,
                RCDMasterID: this.props.refData[0].RCDMasterID
            };
            this.setState({ DryAssetDetails: assetDetails });
    }
    dateTypeFormatter(eventDate: Date) {
        //written considering parameter 'eventDate' sent is IST
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date();
        if (eventDate != null)
            eventdttm = new Date(eventDate.toString());
        var utc = eventdttm.getTime() + (eventdttm.getTimezoneOffset() * 60000);
        var prefDateTime = new Date(new Date(utc).getTime() + (60000 * (parseInt(timeZoneOffset))));
        return prefDateTime;
    }
    AssetNumberOnchange = (event, { newValue }) => {
        event.preventDefault();
        var assetDetails: server.DryAssetDetails = JSON.parse(JSON.stringify(this.state.DryAssetDetails));
        assetDetails.AssetNumber = newValue;
        var fromDate = ReactMoment(this.dateTypeFormatter(new Date())).format('LLL');
        var toDate = ReactMoment(this.dateTypeFormatter(new Date())).add(30, 'days').format('LLL');
        var frmDate = new Date(fromDate);
        var tDate = new Date(toDate);
        assetDetails.FromDate = DateFormat(frmDate, 'mm/dd/yyyy HH:MM:ss');
        assetDetails.ToDate = DateFormat(tDate, 'mm/dd/yyyy HH:MM:ss');
        this.setState({ DryAssetDetails: assetDetails, targetId: event.target.id });
    }
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsAssetNumber: this.getSuggestions(value)
        });
    };

    getSuggestions(value) {
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return (inputLength === 0 || Assetlst.AssetNumberList == null) ? [] : Assetlst.AssetNumberList.filter(AssetNumber =>
            AssetNumber.toLowerCase().slice(0, inputLength) === inputValue);
    };
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsAssetNumber: []
        });
    };
    getSuggestionValue(suggestion) {
        return suggestion;
    }
    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }
    finalSubmit() {
        $('#globalLoader').show();
        var assetDetails: server.DryAssetDetails = JSON.parse(JSON.stringify(this.state.DryAssetDetails));
        var url = Config.ApiBaseUrl + '/api/RcdStatus/EditAssetId';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(assetDetails), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<ValidationSeverityResult>)
            .then(data => {
                $('#globalLoader').hide();
                if (data != null && data != undefined) {
                    if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                        if (data.Result == "Success") {
                            $('#EditAsset .btn-close').click();
                            this.props.refreshRCDStatusGrid();
                        }
                        else
                            PopupWindow.showErrorMessage("Error", data.Result);
                    }
                }
            });
    }
    handleSubmit() {
        var flag = this.validateInput();
        if (flag) {
            if (this.state.DryAssetDetails.AssetNumber != "" && this.state.IsActive == true && this.state.prevDryAssetDetails.AssetNumber!="") {//&& (this.state.DryAssetDetails.AssetNumber != this.state.prevDryAssetDetails.AssetNumber)
            $('#confirmEditModal').show();
            }
            else if (this.state.DryAssetDetails.AssetNumber == "" && this.state.IsActive != true)
            {
                RCNGWindow.ConfirmWindow.showConfirmBoxOK('Information', 'Device ' + this.state.DryAssetDetails.DeviceNumber + ' does not have active association with ' + this.state.prevDryAssetDetails.AssetNumber + '.', this.OkConfirmation.bind(this));
            }
            else
                this.finalSubmit();
        }
    }
    OkConfirmation() {
        RCNGWindow.ConfirmWindow.close();
        $('#EditAsset .btn-close').click();
    }
    performEditAssetYesAction() {
        this.closeModel();
        this.finalSubmit();
    }
    closeModel() {
        $('#confirmEditModal').hide();
    }
    performEditAssetNoAction() {
        this.closeModel();
    }
    componentWillReceiveProps(nextProps: any) {
        var assetDetails: server.DryAssetDetails = {
            AssetNumber: nextProps.refData[0].AssetNumber != null ? nextProps.refData[0].AssetNumber : "", AssetMasterID: nextProps.refData[0].AssetMasterID,
            DeviceNumber: nextProps.refData[0].RCDID,
            RCDMasterID: nextProps.refData[0].RCDMasterID
        };
        this.setState({ DryAssetDetails: assetDetails, prevDryAssetDetails: assetDetails, IsActive: nextProps.refData[0].IsActive });
    }
    validateDryAssetDetails() {
        var currentDetails = this.state.DryAssetDetails;
        var previousDetails = this.state.prevDryAssetDetails;
        if (currentDetails.AssetNumber != previousDetails.AssetNumber)
            return true;

        return false;
    }
    validateInput() {
        if (this.state.DryAssetDetails.AssetNumber.trim().endsWith("-") || this.state.DryAssetDetails.AssetNumber.trim().endsWith("_")) {
            PopupWindow.showErrorMessage("Alert", "Asset # cannot begin/end with hyphen or underscore.");
            return false;
        }
      
        var alphaNumeric = /^([a-zA-Z0-9_-]+)$/;
        var inputVal = this.state.DryAssetDetails.AssetNumber;
        if (!inputVal.match(alphaNumeric) && inputVal!="") {
            PopupWindow.showErrorMessage("Alert", "Dry Asset # should not contain blank space.");
            return false;
        }
        else { 
            //var dryPattern = /^(?![0-9]{4})[A-Za-z0-9]{4}\d{7}$/; //RCNG-2364               
            //if (!inputVal.match(dryPattern)) {
            //    PopupWindow.showErrorMessage("Alert", "Please enter valid Dry Asset #.");
            //    return false;
            //}  
            if (inputVal.length > 11) {//RCNG-2545
                PopupWindow.showErrorMessage("Alert", "Dry Asset # should not be greater than 11 characters.");
                return false;
            }              
        }
        var assetDetailsFlag = this.validateDryAssetDetails();

        if (!assetDetailsFlag) {
            PopupWindow.showErrorMessage("Alert", "Please modify asset details.");
            return false;
        }
        //RCNG-1398
     
        return true;
    }
    public render() {
        const suggestionsAssetNumber = this.state.suggestionsAssetNumber;
        const AssetNumberinputProps = {
            id: 'AssetNumber',
            placeholder: 'Select',
            value: this.state.DryAssetDetails.AssetNumber,
            onChange: this.AssetNumberOnchange.bind(this)
        };
        return <div>
                <div className="row">
                <div className="col-md-2 pe-0 text-md-end">
                    <span className='col-form-label mandatory-label'> Device # :</span>
                    </div>
                    <div className="col-md-4">
                        <input type="text" readOnly className="form-control" id="DeviceNum" maxLength={20} name="SerialNumber" value={this.state.DryAssetDetails.DeviceNumber} />
                    </div>

                <div className="col-md-2 pe-0 text-md-end">
                    <span className='col-form-label'> Asset # :</span>
                    </div>
                    <div className="col-md-4">
                        <div className='input-group'>
                        <Autosuggest name="AssetNumber" id="AssetNumber"
                            suggestions={suggestionsAssetNumber}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue.bind(this)}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={AssetNumberinputProps}
                                highlightFirstSuggestion={true}
                            />
                        </div>
                    </div>
                </div>
            <div className="modal-footer mt-2">
                <button type="button" id="hidePopUpBtn" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.handleSubmit.bind(this)}>Save</button>                
            </div>
            <div className="modal" role="dialog" id="confirmEditModal">
                <div className="modal-dialog mt-5" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.closeModel.bind(this)}>&times;</button>
                           
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert-text m-1">
                                        This Asset ({this.state.prevDryAssetDetails.AssetNumber}) is already paired with device ({this.state.DryAssetDetails.DeviceNumber}). Do you want to modify the pairing ?
                                        </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.performEditAssetNoAction()} >No</button>
                            <button type="button" className="btn btn-primary" onClick={() => this.performEditAssetYesAction()}  >Yes</button>                           
                        </div>
                    </div>
                </div>
            </div>
            </div>
    }
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}